import { render, staticRenderFns } from "./PersonalizationMicrosoftStep1.vue?vue&type=template&id=498c8f02&scoped=true"
import script from "./PersonalizationMicrosoftStep1.vue?vue&type=script&lang=js"
export * from "./PersonalizationMicrosoftStep1.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationMicrosoftStep1.vue?vue&type=style&index=0&id=498c8f02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c8f02",
  null
  
)

export default component.exports